export default {
    setApproveList(state, feeds) {
        state.approveList = feeds;
    },
    setWaitingFeedAnswers(state, answers) {
        state.waitingFeedAnswers = answers;
    },
    setDisasterCrisisIsApproved(state, isapproved) {
        state.disasterCrisisIsApproved = isapproved;
    },
    setCheckAnswerRules (state,rules){
        state.checkAnswerRules = rules;
    },
    setApproveReplyResponse(state,response){
        state.approveReplyResponse = response;
    },
    setIsSent(state,isSent){
        state.isSent = isSent;
    }
};